import { request } from './client'

/* **W-77 / M-22 — WHAT HAPPENED TO YOUR WORK WHILE YOU WERE DOING IT.** Sprint 75.

   The client answered *"in-app only for phase 1"*, which makes this the ONLY place a person
   is ever told these things.

   **IT IS NOT W-61.** "Needs you" is a supervisor's four cards about what is outstanding
   now. This is a list of acts by OTHER PEOPLE about YOUR work, while you were not there —
   a room taken off you, a room you handed in and got back, a fault you reported three weeks
   ago that somebody has finally closed. Nothing else in the product tells you any of them.

   **AND NOTHING IS WRITTEN DOWN.** There is no notification table; every line already
   exists as a row with a time on it. The only storage is one timestamp per person, which is
   what "unread" is measured against. */

export type NotificationCode =
  | 'ROOM_CAME_BACK'
  | 'WORK_TAKEN_OFF_YOU'
  | 'WORK_GIVEN_TO_YOU'
  | 'YOUR_FAULT_WAS_CLOSED'
  /* **CQ-42's TWO, ADDED IN SPRINT 82.** *"…and supervisor should receive a notification
     for it."* The first is the first line on this screen that is not about the reader's
     own work — it is a correction waiting for them to decide — and the widening is the
     client's rather than ours. The second is the answer, to whoever asked. */
  | 'ADJUSTMENT_NEEDS_YOU'
  | 'YOUR_ADJUSTMENT_WAS_DECIDED'

export interface Notification {
  /** Never translated — what the screen branches on to build the sentence. */
  code: NotificationCode
  atUtc: string
  isUnread: boolean
  /** The room this is about — **or, on CQ-42's two lines, the item and the figure**
   *  ("Bath towel -4"). A second field for one code would have put a null on every other
   *  row for ever; the name of this one is the honest cost of that. */
  roomNumber: string | null
  /** **THE PERSON WHO DID IT, AND IT IS THE POINT OF THE ROW.** "Your room was taken off
   *  you" is an event; "Haider took 412 off you, because the guest arrived early" is
   *  something a man can act on, or at least stop wondering about. */
  who: string | null
  whoAr: string | null
  /** Whatever the act itself recorded, verbatim. Never re-asked and never invented. */
  reason: string | null
  subjectId: string | null
}

export interface NotificationsView {
  generatedAtUtc: string
  /** Null when they have never looked — which is not the same as nothing having happened. */
  seenUpToUtc: string | null
  /** **COUNTED FROM THE ROWS THE LIST DRAWS**, never sent beside them. */
  unread: number
  items: Notification[]
}

/** **THE ACTOR IS THE SUBJECT.** There is no parameter naming whose to read. */
export const fetchNotifications = (options: { signal?: AbortSignal } = {}) =>
  request<NotificationsView>(
    '/me/notifications',
    options.signal ? { signal: options.signal } : {})

/** **AN ACT, NOT A SIDE EFFECT OF RENDERING.** A screen that marked everything read as it
 *  drew would clear the list of somebody who opened it on the way elsewhere. */
export const markNotificationsSeen = () =>
  request<void>('/me/notifications/seen', { method: 'POST' })
